<template>
  <div class="layout">
    <div class="header-bar">
      <SelectCdjProjectHeader  @onHeader="onHeader" ref="selectCdjProjectHeader" :items="['type_id','place_id','region_id','project_id']">
        <el-button type="primary" @click="search()" size="mini">查询</el-button>
        <el-button type="primary" @click="getExcel()" size="mini">导出明细</el-button>
        <el-button type="primary" @click="getExcel2()" size="mini">导出明细（带战区）</el-button>
      </SelectCdjProjectHeader>

    </div>
    <div class="content">
      <el-table :data="pageData.data" style="width: 100%" height="calc( 100vh - 280px )" border v-loading="loading">
        <el-table-column label="项目" prop="project_name" width="120" fixed></el-table-column>
        <el-table-column label="总记录数" prop="total_records" width="100"></el-table-column>
        <el-table-column label="整体完成率(%)" prop="overall_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.overall_complete_rate >= 90 ?'success' : scope.row.overall_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.overall_complete_rate}}%</el-link>
          </template>
        </el-table-column>
        <el-table-column label="姓名完成率(%)" prop="name_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.name_complete_rate >= 90 ? 'success' : scope.row.name_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.name_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.name_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="客户等级完成率(%)" prop="category_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.category_complete_rate >= 90 ? 'success' : scope.row.category_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.category_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.category_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="性别完成率(%)" prop="sex_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.sex_complete_rate >= 90 ? 'success' : scope.row.sex_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.sex_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.sex_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="民族完成率(%)" prop="nation_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.nation_complete_rate >= 90 ? 'success' : scope.row.nation_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.nation_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.nation_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="证件类型完成率(%)" prop="credentials_type_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.credentials_type_complete_rate >= 90 ? 'success' : scope.row.credentials_type_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.credentials_type_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.credentials_type_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="证件号码完成率(%)" prop="credentials_code_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.credentials_code_complete_rate >= 90 ? 'success' : scope.row.credentials_code_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.credentials_code_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.credentials_code_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="联系电话完成率(%)" prop="contact_number_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.contact_number_complete_rate >= 90 ? 'success' : scope.row.contact_number_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.contact_number_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.contact_number_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="生日完成率(%)" prop="birthday_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.birthday_complete_rate >= 90 ? 'success' : scope.row.birthday_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.birthday_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.birthday_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="籍贯完成率(%)" prop="native_place_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.native_place_complete_rate >= 90 ? 'success' : scope.row.native_place_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.native_place_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.native_place_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="户籍完成率(%)" prop="registered_residence_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.registered_residence_complete_rate >= 90 ? 'success' : scope.row.registered_residence_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.registered_residence_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.registered_residence_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="家庭地址完成率(%)" prop="home_address_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.home_address_complete_rate >= 90 ? 'success' : scope.row.home_address_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.home_address_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.home_address_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="邮寄地址完成率(%)" prop="post_address_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.post_address_complete_rate >= 90 ? 'success' : scope.row.post_address_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.post_address_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.post_address_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="客户类型完成率(%)" prop="type_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.type_complete_rate >= 90 ? 'success' : scope.row.type_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.type_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.type_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="紧急联系人完成率(%)" prop="emergency_contact_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.emergency_contact_complete_rate >= 90 ? 'success' : scope.row.emergency_contact_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.emergency_contact_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.emergency_contact_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="紧急联系电话完成率(%)" prop="emergency_number_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.emergency_number_complete_rate >= 90 ? 'success' : scope.row.emergency_number_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.emergency_number_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.emergency_number_count}}）</span>
          </template>
        </el-table-column>

        <el-table-column label="工作单位完成率(%)" prop="company_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.company_complete_rate >= 90 ? 'success' : scope.row.company_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.company_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.company_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="单位地址完成率(%)" prop="company_address_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.company_address_complete_rate >= 90 ? 'success' : scope.row.company_address_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.company_address_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.company_address_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="特殊身份完成率(%)" prop="special_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.special_complete_rate >= 90 ? 'success' : scope.row.special_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.special_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.special_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="附件完成率(%)" prop="attachment_complete_rate" width="150">
          <template slot-scope="scope">
            <el-link :type="scope.row.attachment_complete_rate >= 90 ? 'success' : scope.row.attachment_complete_rate >= 60 ? 'warning' : 'danger'">{{scope.row.attachment_complete_rate}}%</el-link>
            <span style="margin-left: 10px">（{{scope.row.attachment_count}}）</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" width="180"></el-table-column>
        <el-table-column label="更新时间" prop="update_time" width="180"></el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <el-pagination
        layout="prev, pager, next"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        :total="pageData.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>

import SelectCdjProjectHeader from "../../../../Butler/components/common/SelectCdjProjectHeader";
export default {
  name: "CustomerCompleteness",
  components: {SelectCdjProjectHeader},
  inject: ['mainObj'],
  data() {
    return {
      where:{
        project_id:null,
        project_ids:'',
        level:'',
      },
      loading:false,
      pageData: {
        data:[],
        total:0,
        current_page:1,
        per_page:30,
      },
    }
  },
  mounted() {
    const that=this;
    that.$nextTick(() => {
      that.$refs.selectCdjProjectHeader.getAllTree(()=>{
        that.$refs.selectCdjProjectHeader.initLegalSearchObj()
        that.handleCurrentChange();
      });
    });
  },
  methods:{
    onHeader(header) {
      this.where.project_ids=header.project_ids;
      this.where.project_id=header.project_name;
      this.where.level=header.level;
      this.handleCurrentChange();
    },
    getList(){
      const that = this
      that.loading=true
      ERP.postRequest({
        url: `/admin/CustomerCompleteness/getList?page=${that.pageData.current_page}&limit=${that.pageData.per_page}`,
        data: {
          ...that.where
        }
      },res=>{
        that.loading=false
        if(res.code === 1){
          that.pageData = res.data
        }
      })
    },
    search(){
      this.pageData.current_page=1;
      this.getList()
    },
    handleCurrentChange(currentPage=1){
      const that=this;
      that.pageData.current_page=currentPage;
      that.getList()
    },
    getExcel(){
      const that = this
      that.loading=true
      ERP.postRequest({
        url: `/admin/CustomerCompleteness/getExportExcel`,
        data: {
          ...that.where
        }
      },res=>{
        that.loading=false
        if(res.code === 1){
          window.open(res.data)
        }
      })
    },
    getExcel2(){
      const that = this
      that.loading=true
      ERP.postRequest({
        url: `/admin/CustomerCompleteness/getExportExcel2`,
        data: {
          ...that.where
        }
      },res=>{
        that.loading=false
        if(res.code === 1){
          window.open(res.data)
        }
      })
    },
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.layout{
  display: flex;
  flex-direction: column;
  height: 100%;

  .header{
    display: flex;
  }

  .content{
    //flex: 1;
    //display: flex;
    //flex-direction: column;
    //align-items: center;
    //justify-content: center;
  }

  .footer{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/customer-log/components/CustomerCompleteness.vue